import { motion } from "framer-motion";

// Fast, legible reveal — text stays readable at all times. Fires as soon as
// element touches the viewport and never reverses. `variant` gives a bit of
// rhythm across a long page without resorting to lateral "flying text":
//   "up"    — default. Small 12px lift, quick 250ms ease-out.
//   "scale" — soft opacity+scale emphasis for the page's big statement
//             beats (quotes, thesis lines) — a little slower, a little
//             heavier, so those moments read as more consequential.
const VARIANTS = {
  up: {
    initial: { opacity: 0.3, y: 12 },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 0.25, ease: "easeOut" },
  },
  scale: {
    initial: { opacity: 0.15, scale: 0.97 },
    whileInView: { opacity: 1, scale: 1 },
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
  },
};

export function RevealSection({ children, className = "", delay = 0, as = "section", variant = "up", ...rest }) {
  const Component = motion[as] || motion.div;
  const v = VARIANTS[variant] || VARIANTS.up;
  return (
    <Component
      className={className}
      initial={v.initial}
      whileInView={v.whileInView}
      viewport={{ once: true, amount: 0.05 }}
      transition={{ ...v.transition, delay }}
      {...rest}
    >
      {children}
    </Component>
  );
}
